import { useCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { QueryParameters as SDUICategoryPageLayoutQueryParameters } from "@faire/web-api--source/endpoints/www/api/v3/layout/browse/navigationPath/placement/get";
import { useQuery as useSDUICategoryPageLayoutQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/browse/navigationPath/placement/get-hooks";
import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";

export const useBrowseLayoutQuery = (placement: ViewLayoutPlacement) => {
  const navigationPath = useCurrentNavigationPath();

  return useSDUICategoryPageLayoutQuery(
    encodeURIComponent(navigationPath),
    placement,
    SDUICategoryPageLayoutQueryParameters.build({}),
    {
      staleTime: Infinity,
    }
  );
};
